import { BLACKOUT_URL_STATUS } from '../consts/BlackoutPeriod.consts';

/**
 * Map each URL id → list of blackout period statuses that URL appears in.
 *
 * @param {Array<{ status: string, url_ids?: number[], urls?: Array<{ id: number }> }>} blackoutPeriods
 * @returns {Record<string, string[]>}
 */
export function buildUrlBlackoutStatusByUrlId(blackoutPeriods) {
  const map = {};
  (blackoutPeriods || []).forEach((period) => {
    const status = period.status;
    if (!status) {
      return;
    }
    const urlIds = (period.url_ids && period.url_ids.length)
      ? period.url_ids
      : (period.urls || []).map((u) => u.id).filter((id) => id != null);

    urlIds.forEach((urlId) => {
      const key = String(Number(urlId));
      if (!map[key]) {
        map[key] = [];
      }
      if (!map[key].includes(status)) {
        map[key].push(status);
      }
    });
  });
  return map;
}

/**
 * @param {number|string} urlId
 * @param {Record<string, string[]>} statusByUrlId
 * @param {string[]} selectedStatuses
 */
export function urlMatchesBlackoutStatusFilter(urlId, statusByUrlId, selectedStatuses) {
  if (!selectedStatuses || selectedStatuses.length === 0) {
    return false;
  }
  const statuses = statusByUrlId[String(Number(urlId))] || [];
  const hasNoBlackout = statuses.length === 0;

  return selectedStatuses.some((filter) => {
    if (filter === BLACKOUT_URL_STATUS.NONE) {
      return hasNoBlackout;
    }
    return statuses.includes(filter);
  });
}
